const BASE_URL = "https://borntocamp.de";
const DEFAULT_SOCIAL_IMAGE = `${BASE_URL}/Images/born_to_camp_1200x630.png`;
const DEFAULT_TWITTER_CARD = "summary_large_image";

const SEO_CONFIG = {
  "/": {
    en: {
      title: "Motorhomes & Campers for Rent in Regensburg | Born To Camp",
      description:
        "Rent a motorhome in Regensburg, rent a caravan in Regensburg, rent a camper in Regensburg, rent a camper van in Regensburg, rent a motorhome with a dog at Born To Camp.",
      keywords:
        "Wohnmobil Mieten Regensburg, Wohnwagen Mieten Regensburg, Camper Mieten Regensburg, Campingbus Mieten Regensburg, Wohnmobil Mieten Burglengenfeld, Camper Mieten in Der Naehe, Wohnmobil Mieten in Der Naehe, Born to Camp, Wohnmobil Mit Hund Mieten, camper mit hund mieten",
    },
    de: {
      title: "Wohnmobil & Camper Mieten in Regensburg | Born To Camp",
      description:
        "Camper & Wohnmobil mieten in Regensburg - komplett ausgestattet, hundefreundlich und ohne Servicegebühr. Jetzt Verfügbarkeit prüfen!",
      keywords:
        "Wohnmobil Mieten Regensburg, Wohnwagen Mieten Regensburg, Camper Mieten Regensburg, Campingbus Mieten Regensburg, Wohnmobil Mieten Burglengenfeld, Camper Mieten in Der Naehe, Wohnmobil Mieten in Der Naehe, Born to Camp, Wohnmobil Mit Hund Mieten, camper mit hund mieten",
    },
    schema: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Born To Camp",
      "url": "https://borntocamp.de/"
    }
  },
  "/offers": {
    en: {
      title: "Save Up to 25% & Get a 20€ Voucher on Campers| Born To Camp",
      description:
        "Unlock exclusive camper deals with Born To Camp. Save up to 25% and receive a 20€ voucher for your next adventure. Explore our offers now!",
    },
    de: {
      title: "Spare bis zu 25 % und erhalte einen 20€ Gutschein für Camper | Born To Camp",
      description:
        "Nutze exklusive Camper-Angebote bei Born To Camp. Spare bis zu 25% und erhalte einen 20€ Gutschein auf deine Reisemobil Miete. Jetzt Angebote entdecken!",
    },
  },
  "/campers": {
    en: {
      title: "Rent Westfalia Kelsey, Pössl, Giottiline & Chausson",
      description:
        "Westfalia Kelsey rentals, Pössl rentals, Giottiline rentals, Chausson rentals and Pössl van rentals for your adventure. Book with us now!",
      keywords:
        "Westfalia Kelsey Mieten, Pössl mieten, Giottiline mieten, Chausson mieten, Pössl Kastenwagen mieten",
    },
    de: {
      title: "Westfalia Kelsey, Pössl, Giottiline & Chausson Mieten",
      description:
        "Westfalia Kelsey mieten, Pössl mieten, Giottiline mieten, Chausson mieten und Weinsberg Wohnwagen mieten für dein Abenteuer. Jetzt bei uns buchen!",
      keywords:
        "Westfalia Kelsey Mieten, Pössl mieten, Giottiline mieten, Chausson mieten, Pössl Kastenwagen mieten",
    },
  },
  "/campersubscription": {
    en: {
      title: "Flexible Camper Subscription from 499€/Month | Born To Camp",
      description:
        "Discover Born To Camp's camper subscription from 499€/month. Choose your ideal model and enjoy a flexible, worry-free adventure. Book your RV today!",
    },
    de: {
      title: "Flexibles Camper Abo ab 499€ pro Monat | Born To Camp",
      description:
        "Entdecke das Camper-Abo von Born To Camp ab 499€/Monat. Wähle dein Modell und genieße deine Camper Langzeitmiete. Jetzt Abenteuer buchen!",
    },
  },
  "/campersale": {
    en: {
      title: "Camper for Sale: Westfalia, Pössl, Chausson | Born To Camp",
      description:
        "Buy a camper: Proven motorhome for sale. Buy Westfalia Kelsey, Buy Pössl Panel Van, Buy Chausson Panel Van at Born To Camp.",
      keywords:
        "Camper Kaufen, Bewährtes Reisemobil Zum Verkauf, Westfalia Kelsey Kaufen, Pössl Kastenwagen Kaufen, Chausson Kastenwagen Kaufen",
    },
    de: {
      title: "Camper Kaufen: Westfalia Kelsey, Pössl, Chausson | Born To Camp",
      description:
        "Camper Kaufen: Bewährtes Reisemobil zum Verkauf. Westfalia Kelsey Kaufen, Pössl Kastenwagen Kaufen, Chausson Kastenwagen Kaufen bei Born To Camp.",
      keywords:
        "Camper Kaufen, Bewährtes Reisemobil Zum Verkauf, Westfalia Kelsey Kaufen, Pössl Kastenwagen Kaufen, Chausson Kastenwagen Kaufen",
    },
  },
  "/tripplanner": {
    en: {
      title: "Custom Travel Planner for Your Perfect Road Trip | Born To Camp",
      description:
        "Plan your dream road trip with our custom Travel Planner. Enjoy tailored routes, top campsites, and exciting activities. Book now for a stress-free vacation!",
    },
    de: {
      title: "Individueller Reiseplaner für deinen perfekten Roadtrip | Born To Camp",
      description:
        "Erhalte deinen Traum-Roadtrip mit unserem maßgeschneiderten Reiseplaner. Genieße individuelle Routen, Top-Campingplätze und spannende Aktivitäten. Jetzt buchen!",
    },
  },
  "/blog": {
    en: {
      title: "Blogs | Tips & Guides for Camper Adventures | Born To Camp",
      description:
        "Explore our blog for top tips on camper travel, from family trips to solo adventures. Discover guides on saving costs, destination highlights, and more!",
    },
    de: {
      title: "Blog | Tipps & Guides für Camper Abenteuer | Born To Camp",
      description:
        "Entdecke unseren Blog für Top-Tipps zum Camper-Reisen, von Familienausflügen bis Solo-Abenteuern. Finde Ratgeber zu: Kosten sparen beim Campen, Reiseziele und mehr!",
    },
  },
  "/aboutus": {
    en: {
      title: "About Us | Meet the Team at Born To Camp | Our Mission & Values",
      description:
        "Meet our team and discover how we ensure hassle-free, unforgettable travel experiences with transparency and dedication.",
    },
    de: {
      title: "Über Uns | Unser Team | Unsere Mission & Werte | Born To Camp",
      description:
        "Lerne unser Team kennen und erfahre, wie wir durch Transparenz und Engagement sorgenfreie, unvergessliche Reiseerlebnisse garantieren.",
    },
  },
  "/contactus": {
    en: {
      title: "Contact Us | Help Center, FAQs & Support | Born To Camp",
      description:
        "Get answers to camper rental, subscription, and travel planning questions at our Help Center. Access support, videos, and our contact form for help.",
    },
    de: {
      title: "Kontakt | Hilfezentrum, häufig gestellte Fragen & Support | Born To Camp",
      description:
        "Erhalte Antworten auf Fragen zur Wohnmobilvermietung, Wohnmobil Abo und Reisemobil Ankauf in unserem Helpcenter. Nutze unsere Videos, Telefon & Kontaktformular für persönliche Hilfe.",
    },
    schema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Are there long-term discounts available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we offer long-term discounts: 5% for 8+ days, 10% for 15+ days, and 15% for 22+ days. These are automatically applied during booking."
          }
        },
        {
          "@type": "Question",
          "name": "Who is eligible to rent a camper?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Anyone at least 21 years old who has held a Class B driver's license for at least one year. International licenses are accepted if valid in Germany."
          }
        },
        {
          "@type": "Question",
          "name": "Can I bring my dog with me?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes! Select the 'Dog Camper' option when booking. A deep cleaning fee applies. The camper must still be returned cleaned."
          }
        },
        {
          "@type": "Question",
          "name": "How far in advance should I book a camper?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "It is recommended to book as early as possible, especially during peak season, as popular dates fill up quickly."
          }
        }
      ]
    }
  },
  "/login": {
    en: {
      title: "Login | Manage Your Booking & Access Info | Born To Camp",
      description:
        "Log in to manage your reservation, add accessories, or view videos. Use your email and password from your confirmation to access our booking portal.",
    },
    de: {
      title: "Login | Buchung verwalten & Informationen abrufen | Born To Camp",
      description:
        "Melde dich an, um deine Reservierung zu verwalten, Zubehör hinzuzufügen oder Camper Erklärvideos anzusehen. Verwende deine E-Mail und das Passwort aus der Bestätigungsmail zum Login.",
    },
  },
  "/equipment": {
    en: {
      title: "Equipment | Rent Extras for Your Camper | Born To Camp",
      description:
        "Enhance your camper experience with extra items like hammocks, blankets, or bikes. Add them to your booking to make your journey unique!",
    },
    de: {
      title: "Zubehör | Extras für deinen Camper mieten | Born To Camp",
      description:
        "Verbessere deine Camper Miete mit extra Zubehör wie Hängematte, Klimaanlage, Fahrradträger und vieles mehr. Füge sie deiner Buchung hinzu, um deine Reise einzigartig zu gestalten!",
    },
  },
  "/explanatoryvideo": {
    en: {
      title: "Explanatory Videos | Camper Rental & Travel Help | Born To Camp",
      description:
        "Find answers to your questions about camper rentals, subscriptions, and travel planning at Born To Camp. Contact us for support or explore our helpful guides.",
    },
    de: {
      title: "Erklärvideos | Wohnmobilvermietung & Reisehilfe | Born To Camp",
      description:
        "Finde Antworten auf deine Fragen zur Camper Miete. Unsere Videos erklären die Handhabung all unserer Modelle. Kontaktiere uns für weitere Unterstützung.",
    },
  },
  "/voucher": {
    en: {
      title: "Vouchers & Camper Rentals | Born to Camp",
      description:
        "Discover exciting camper rentals and vouchers with Born to Camp. Plan your adventure, create lasting memories, and enjoy unforgettable experiences today!",
    },
    de: {
      title: "Gutschein für deine Camper Miete | Born to Camp",
      description:
        "Verschenke einen Abenteuerurlaub mit Camper Miete Gutscheinen von Born to Camp. Plane dein Abenteuer, schaffe bleibende Erinnerungen und genieße unvergessliche Erlebnisse!",
    },
  },
};

module.exports = {
  BASE_URL,
  DEFAULT_SOCIAL_IMAGE,
  DEFAULT_TWITTER_CARD,
  SEO_CONFIG
};
